import type { ReactNode } from 'react'
import React from 'react'

import * as S from './AnalyticsLayout.styled'

export type AnalyticsLayoutProps = {
  children: ReactNode
  toolbar?: ReactNode
}

export const AnalyticsLayout = ({ toolbar, children }: AnalyticsLayoutProps) => {
  return (
    <S.Container>
      {toolbar}
      <S.Grid>{children}</S.Grid>
    </S.Container>
  )
}
